import { render, staticRenderFns } from "./CustomCalendar.html?vue&type=template&id=2b3fcaa2&external"
import script from "./CustomCalendar.vue?vue&type=script&lang=js"
export * from "./CustomCalendar.vue?vue&type=script&lang=js"
import style0 from "./CustomCalendar.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/run/media/nick/Development/Projects/Concrete Cms/kleymenov.pro/application/blocks/custom_calendar/templates/calenadar_with_event_list/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b3fcaa2')) {
      api.createRecord('2b3fcaa2', component.options)
    } else {
      api.reload('2b3fcaa2', component.options)
    }
    module.hot.accept("./CustomCalendar.html?vue&type=template&id=2b3fcaa2&external", function () {
      api.rerender('2b3fcaa2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CustomCalendar/CustomCalendar.vue"
export default component.exports